export default __webpack_public_path__ + "static/media/portugal-digital-nomad-visa-available.225300b5.jpg";